export type DrawData = {
    scale: number; // screen pixels = scale X image pixels
    xOffset: number; // screen pixel displacement of image from left of canvas
    yOffset: number; // screen pixel displacement of image from top of canvas
    width: number; // screen pixel width of the image
    height: number; // screen pixel height of the image
};

export const DefaultDrawData: DrawData = {
    scale: 1,
    xOffset: 0,
    yOffset: 0,
    width: 0,
    height: 0,
};

export const calculateDrawData = (canvas: HTMLCanvasElement | null, backgroundImage: HTMLImageElement | null) => {
    if (!canvas) {
        return DefaultDrawData;
    }
    if (!backgroundImage) {
        return {
            ...DefaultDrawData,
            width: canvas.width,
            height: canvas.height,
        };
    }

    const vScale = canvas.height / backgroundImage.height;
    const hScale = canvas.width / backgroundImage.width;
    const scale = Math.min(vScale, hScale);
    const width = Math.floor(scale * backgroundImage.width);
    const height = Math.floor(scale * backgroundImage.height);
    const xOffset = Math.floor((canvas.width - width) / 2);
    const yOffset = Math.floor((canvas.height - height) / 2);

    return {
        scale,
        xOffset,
        yOffset,
        width,
        height,
    };
};



// WEBPACK FOOTER //
// ./src/ui/shared/calculateDrawData.ts